import script from "./ModelDetallePedido.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModelDetallePedido.vue?vue&type=script&setup=true&lang=ts"

import "./ModelDetallePedido.vue?vue&type=style&index=0&id=6131f6c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6131f6c8"]])

export default __exports__